import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { color, typography } from "styled-system";
import { getCurrencyLabel } from "utils/utils";

const Symbol = styled("div")`
  width: ${(props) => {
    return props.size ? props.size : "1em";
  }};
  height: ${(props) => (props.size ? props.size : "1em")};
  flex: 0 0 ${(props) => (props.size ? props.size : "1em")};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: ${(props) => (props.size ? props.size : "1em")};
`;

const SymbolList = styled("div")`
  display: flex;
  width: 100%;
  color: #1e1e1e;
  font-weight: 400;
  font-size: 14px;
  align-items: center;
  ${typography}

  ${({ textAlign }) => {
    if (textAlign === "center") {
      return `justify-content: ${textAlign};`;
    }
  }}
  > div:first-child {
  }

  .symbolName {
    padding-right: 8px;
    padding-left: 8px;
    font-weight: 700;
    ${typography}
  }
  ${({ text }) => {
    if (text) {
      return `
        .symbolName {
          padding-right: 4px;
        }
      `;
    }
  }}
  ${color}
`;

export default React.memo((props) => {
  const { app = {} } = useSelector((state) => state);

  const { currencies = [], locale } = app;

  const {
    symbol,
    showFullname,
    showName,
    showSymbol,
    color,
    text,
    ...restProps
  } = props;

  const [currency, setCurrency] = useState({});

  const tryImg = (symbol) => {
    try {
      return require(`assets/images/flags/${symbol}.jpg`);
    } catch (err) {
      return null;
    }
  };

  const getOptionLabel = (option) => getCurrencyLabel(option, locale);

  let img = tryImg(symbol);

  if (symbol === "global_white") {
    img = require(`assets/images/global-white.png`);
  }

  useEffect(() => {
    if (symbol && currencies.length > 0) {
      setCurrency(currencies.find((currency) => currency.value === symbol));
    }
  }, [currencies, symbol]);

  if (!showFullname && !showName && !showSymbol) {
    return (
      <Symbol
        style={{ backgroundImage: `url(${img})` }}
        className="symbolImg"
        {...props}
      />
    );
  } else {
    return (
      <SymbolList color={color} {...restProps} text={text}>
        <Symbol
          style={{ backgroundImage: `url(${img})` }}
          className="symbolImg"
          {...props}
        />
        <span className={"symbolName"}>
          {showName && symbol}
          {showSymbol && currency && (
            <React.Fragment>
              {"\u00A0"}
              {currency.currencySymbol}
            </React.Fragment>
          )}
        </span>
        {text && <span>{text}</span>}
        {showFullname && currency && <span>{getOptionLabel(currency)}</span>}
      </SymbolList>
    );
  }
});
